'use client';

import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import React, { useState, forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

interface MagicCodeMaskProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
}

const MagicCodeMask = forwardRef<HTMLInputElement, MagicCodeMaskProps>((props, ref) => {
	const { onChange, ...other } = props;
	return (
		<IMaskInput
			{...other}
			mask="####-####-####-####"
			definitions={{
				'#': /^[a-zA-Z0-9_]+$/,
			}}
			inputRef={ref}
			onAccept={(value: string) => onChange({ target: { name: props.name, value } })}
			overwrite
		/>
	);
});

MagicCodeMask.displayName = 'MagicCodeMask';

interface MagicCodeFieldProps {
	onChange: (code: string) => void;
	label?: string;
	initial?: string;
	placeholder?: string;
}

function MagicCodeField({ onChange, label, initial, placeholder }: MagicCodeFieldProps) {
	const [magicCode, setMagicCode] = useState(initial || '');

	const handleChange = (event: { target: { value: string } }) => {
		const code = event.target.value.toUpperCase();
		setMagicCode(code);
		if (code.length === 19) onChange(code);
		else onChange('');
	};

	return (
		<FormControl fullWidth>
			<TextField
				label={label}
				placeholder={placeholder}
				value={magicCode}
				onChange={handleChange}
				style={{ marginTop: 24, marginBottom: 24 }}
				InputProps={{
					inputComponent: MagicCodeMask as never,
				}}
				variant="outlined"
			/>
		</FormControl>
	);
}

MagicCodeField.displayName = 'MagicCodeField';

export { MagicCodeField };
export default MagicCodeField;

